module.exports = __webpack_public_path__ + "static/media/Marcos.9fa565f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Marcos.jpg
// module id = 232
// module chunks = 0